import { DEFAULT_ERROR_MESSAGE } from '../../constants/messages';
import { prepareNewbuildingBroker } from '../../containers/RequestFormModalWindow/utils/newbuildingBroker';
import { TCreateConsultingRequestRequest } from '../../repositories/newbuilding-flat-view-order/v1/create-consulting-request';
import { selectUtm } from '../../selectors/utm';
import { createConsultingRequest } from '../../services/consultingRequest';
import { TThunkAction } from '../../types/redux/thunk';
import { createError } from '../../utils/notification';
import { setHhConversionId } from '../cpa';
import { pushNotification } from '../notifications';
import { setRequestFailure, setRequestSubmitting, setRequestSuccess } from '../pageState';

export const createConsultingRequestAction = (
  parameters: TCreateConsultingRequestRequest,
): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    dispatch(setRequestSubmitting());

    try {
      parameters.newbuildingBroker = prepareNewbuildingBroker(context.config);
      parameters.utm = selectUtm(getState()) ?? undefined;

      const response = await createConsultingRequest({ httpApi, parameters });

      dispatch(setRequestSuccess());
      dispatch(setHhConversionId({ hhConversionId: response.hhConversionId }));
    } catch (ex) {
      logger.error(ex, {
        domain: 'actions/consultingRequest/createConsultingRequestAction',
      });

      dispatch(pushNotification(createError(DEFAULT_ERROR_MESSAGE)));
      dispatch(setRequestFailure());

      throw ex;
    }
  };
};
